import axios from "../../api/axiosInstance";
import { STATUS, getProjectId, extractErrorInfo } from "./sharedfunction";

export async function getProjectsList({ sortField = 'name', sortOrder = 'asc', query, filterAst, page = 1, pageSize = 25 } = {}) {
  try {
    const projectId = getProjectId();
    let url = `${process.env.REACT_APP_API_URL}/project/getProjects`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }

    const payload = {
      page,
      pageSize
    };
    if (sortField) payload.sortField = sortField;
    if (sortOrder) payload.sortOrder = sortOrder;
    if (query) payload.query = query;
    if (filterAst) payload.filterAst = filterAst;

    const response = await axios.post(
      url,
      payload,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || [],
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching projects list:", error);
    return extractErrorInfo(error);
  }
}

export async function getProjectInfo() {
  try {
    const projectId = getProjectId();
    
    if (!projectId) {
      return {
        status: STATUS.ERROR,
        error: "Project ID is required",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/project/getProjectInfo/${projectId}?projectId=${projectId}`,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error fetching project info:", error);
    return extractErrorInfo(error);
  }
}

export async function generateUniquePrefixForProject({ projectName } = {}) {
  try {
    if (!projectName) {
      return {
        status: STATUS.ERROR,
        error: "Project name is required",
      };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/project/generateUniquePrefixForProject`,
      {
        params: { projectName },
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || "",
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error generating unique prefix:", error);
    return extractErrorInfo(error);
  }
}

export async function createProject({ name, prefix, description, context } = {}) {
  try {
    if (!name || !prefix) {
      return {
        status: STATUS.ERROR,
        error: "Name and prefix are required",
      };
    }

    const payload = {
      name,
      prefix,
      ...(description && { description }),
      ...(context && { context }),
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/project/createProject`,
      payload,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error creating project:", error);
    return extractErrorInfo(error);
  }
}

export async function updateProject({ id, name, description, context } = {}) {
  try {
    if (!id || !name) {
      return {
        status: STATUS.ERROR,
        error: "ID and name are required",
      };
    }

    const payload = {
      id,
      name,
      ...(description !== undefined && { description }),
      ...(context !== undefined && { context }),
    };

    const projectId = getProjectId();
    let url = `${process.env.REACT_APP_API_URL}/project/update`;
    if (projectId) {
      url += `?projectId=${projectId}`;
    }

    const response = await axios.put(
      url,
      payload,
      {
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        data: response?.data?.data || {},
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error updating project:", error);
    return extractErrorInfo(error);
  }
}

export async function deleteProject({ ids } = {}) {
  try {
    if (!ids || !Array.isArray(ids) || ids.length === 0) {
      return {
        status: STATUS.ERROR,
        error: "At least one project ID is required",
      };
    }

    const response = await axios.delete(
      `${process.env.REACT_APP_API_URL}/project/delete`,
      {
        data: { ids },
        withCredentials: true,
      }
    );

    if (response?.data?.success) {
      return {
        status: STATUS.SUCCESS,
        message: response?.data?.message,
      };
    }

    return {
      status: STATUS.ERROR,
      error: response?.data?.message || response?.data?.error,
      errors: response?.data?.errors,
    };
  } catch (error) {
    console.error("Error deleting project(s):", error);
    return extractErrorInfo(error);
  }
}


